// Saanjh theme JS
document.addEventListener('DOMContentLoaded', function() {

  // Quick add to cart via Shopify AJAX API
  document.querySelectorAll('.quick-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '✓ Added';
        // refresh bag count
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var count = document.querySelector('.bag-count');
          if (count) count.textContent = cart.item_count;
        });
        setTimeout(function() { btn.textContent = '+ Quick Add'; }, 1600);
      })
      .catch(function() {
        btn.textContent = '+ Quick Add';
        alert('Could not add to bag — please try again.');
      });
    });
  });

  // Hero dot rotation (visual only)
  var dots = document.querySelectorAll('.hero-dots span');
  if (dots.length > 1) {
    var idx = 0;
    setInterval(function() {
      dots.forEach(function(d) { d.classList.remove('active'); });
      idx = (idx + 1) % dots.length;
      dots[idx].classList.add('active');
    }, 4500);
  }

});
